<template>
  <el-image-viewer
    v-if="isShow"
    :urlList="urlList"
    :zIndex="options.zIndex"
    :initialIndex="options.initialIndex"
    :infinite="options.infinite"
    :hideOnClickModal="options.hideOnClickModal"
    @close="close"
  />
</template>

<script>
import { defineComponent, ref, reactive } from 'vue';
import { ElImageViewer } from 'element-plus';
export default defineComponent({
  name: 'ImageViewer',
  components: {
    ElImageViewer
  },
  setup() {
    const urlList = [];
    const isShow = ref(false);
    const options = reactive({
      zIndex: 2000,
      initialIndex: 0,
      infinite: true,
      hideOnClickModal: false
    });

    const close = () => {
      isShow.value = false;
    };
    return {
      urlList,
      options,
      isShow,
      close
    };
  }
});
</script>
